import { put, call, takeLatest } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import CustomerTransferGateway from '~apis/customerTransfer';
import UtilFunctions from '~utils/functions';
import { MetalTypeEnum, TransactionStatusEnum } from '~utils/enums';

export default function* watchGetExportCustomerTransferListing(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeLatest('customerTransfer/customerTransferGetExportCustomerTransferAttempt', handleGetExportCustomerTransferListing, api);
}

function* handleGetExportCustomerTransferListing(api: CustomerTransferGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        filters: {
            senderName,
            senderIdNo,
            receiverName,
            receiverIdNo,
            status,
            dateFrom,
            dateTo,
            branchName,
            metalType,
            productId,
        }
    } = reduxState.customerTransfer.customerTransferListing;

    const allBranches = reduxState.branch.allBranches;
    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    const response = yield* call([api, api.exportCustomerTransferListing], {
        authToken,
        senderName: senderName ? senderName : undefined,
        senderIdNo: senderIdNo ? senderIdNo : undefined,
        receiverName: receiverName ? receiverName : undefined,
        receiverIdNo: receiverIdNo ? receiverIdNo : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
        productId: productId !== 0 ? productId : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerTransferGetExportCustomerTransferFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerTransferGetExportCustomerTransferSuccess(response.data));
    }
}
